export const CHARTS_DASHBOARD = "chartsDashboard";
